import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  Avatar,
  Typography,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  CssBaseline,
  Box,
  useMediaQuery,
  Badge,
  MenuItem,
  Menu,
  Modal,
  FormControlLabel,
  FormControl,
  InputLabel,
  Switch,
  Select,
  Grid,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import avatar from "../../Assets/Images/close-up-portrait-young-bearded-man-white-shirt-jacket-posing-camera-with-broad-smile-isolated-gray_171337-629.jpg";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import GroupIcon from "@mui/icons-material/Group";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import ChangePasswordModal from "../Modals/ChangePasswordModal";
import LockResetIcon from "@mui/icons-material/LockReset";
import CircleIcon from "@mui/icons-material/Circle";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import CommonButton from "../InputComponents/CommonButton";
import SelectInput from "../InputComponents/SelectInput";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import RuleFolderIcon from "@mui/icons-material/RuleFolder";
import WorkIcon from "@mui/icons-material/Work";
import { ClientLayoutProvider } from "../Context/CandidateLayoutContext";
import { axiosAPI } from "../AxiosComponents/Axios";

const menuItems = [
  {
    label: "Dashboard",
    icon: (
      <HomeIcon sx={{ fontSize: "25px", position: "relative", right: "4px" }} />
    ),
    path: "/",
  },

  {
    label: "Jobs",
    icon: (
      <WorkIcon sx={{ fontSize: "25px", position: "relative", right: "4px" }} />
    ),
    path: "/Jobs",
  },

  {
    label: "Candidates",
    icon: (
      <GroupIcon
        sx={{ fontSize: "25px", position: "relative", right: "5px" }}
      />
    ),
    path: "/Candidates",
  },

  {
    label: "Deployed Candidates",
    icon: (
      <HowToRegIcon
        sx={{ fontSize: "25px", position: "relative", right: "5px" }}
      />
    ),
    path: "/DeployedCandidates",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function NavbarSidebarLayoutClient({
  viewNav = true,
  children,
}) {
  const isMobile = useMediaQuery("(max-width: 1220px)");
  const Navigate = useNavigate();
  const location = useLocation();

  const [openModal, setOpenModal] = useState(false);

  const [autoDelete, setAutoDelete] = useState(true);
  const [deleteFrequency, setDeleteFrequency] = useState("7");

  const [FontFamilyValue, setFontFamily] = useState("Geist, sans-serif");
  const [fontWeightValue, setfontWeightValue] = useState("400");
  const [isCollapsed, setIsCollapsed] = useState(false);

  const [notificationCount, setNotificationCount] = useState(23);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const [openSubMenu2, setOpenSubMenu2] = useState(null);

  useEffect(() => {
    const activeMenu = menuItems.find((item) =>
      item.subItems?.some((subItem) => subItem.path === location.pathname)
    );

    if (activeMenu) {
      setOpenSubMenu2(activeMenu.label);
    }
  }, [location.pathname]);

  const handleSubMenuToggle2 = (label) => {
    setOpenSubMenu2((prev) => (prev === label ? null : label));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [clientData, setClientData] = useState({});

  const getData = async () => {
    const id =
      localStorage?.getItem("SWA_UserId") ||
      sessionStorage?.getItem("SWA_UserId");
    try {
      const res = await axiosAPI?.get(`/Client/listbyUserId/${id}`);
      setClientData(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        margin: "0px",
      }}
    >
      <ChangePasswordModal
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
      <CssBaseline />

      {/* Sidebar */}

      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isCollapsed || !isMobile}
        onClose={() => setIsCollapsed(false)}
        sx={{
          display: viewNav ? "block" : "none",
          width: isMobile ? 240 : isCollapsed ? 135 : 260,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            transition: "width 0.3s ease-in-out",
            width: isMobile ? 240 : isCollapsed ? 135 : 260,
            background: "#006CB8",
            color: "white",
            borderRadius: "0px 50px 0px 0px",
            margin: isMobile ? "0px" : "0px 10px 0px 0px",
            border: "2px solid #006CB8",
            overflowX: "hidden",
          },
        }}
      >
        <List
          sx={{
            background: "#006CB8",
            minHeight: "76px",
          }}
        >
          {!isMobile && (
            <IconButton
              edge="start"
              sx={{
                position: "relative",
                left: isCollapsed ? "10px" : "17px",
                transition: "all 0.1s ease-in-out",
              }}
            >
              <MenuIcon
                sx={{ color: "white", fontSize: "40px" }}
                onClick={() => setIsCollapsed(!isCollapsed)}
              />
              <Typography
                sx={{
                  fontFamily: FontFamilyValue,
                  color: "white",
                  fontSize: "22px",
                  fontWeight: fontWeightValue,
                  margin: "0px 12px",
                }}
                onClick={() => {
                  Navigate(`/`);
                }}
              >
                Client
              </Typography>
            </IconButton>
          )}
        </List>

        <List sx={{ padding: "10px" }}>
          {menuItems.map((item, index) => {
            const isSubMenuOpen = openSubMenu2 === item.label;
            const hasSubItems = !!item.subItems;
            const isSubItemActive = item.subItems?.some(
              (sub) => sub.path === location.pathname
            );
            const isItemActive =
              !hasSubItems && item.path === location.pathname;

            const isActiveCollapsed =
              isCollapsed && (isItemActive || isSubItemActive);
            const isActiveExpanded = !isCollapsed && !isMobile && isItemActive;

            const isActive = isActiveCollapsed || isActiveExpanded;

            const parentStyles = {
              color: isActive ? "#006CB8" : "white",
              background: isActive ? "white" : "#006CB8",
              fontweight: isActive ? "700" : "600",
              cursor: "pointer",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: isActive ? "white" : "#006CB8",
                color: isActive ? "#006CB8" : "white",
                transition: "all 0.3s ease-in-out",
              },
            };

            return (
              <div key={index}>
                <ListItem
                  button
                  onClick={() => {
                    // if sidebar is closed, clicking the icon with submenu wont toggle submenu. Just the whole sidebar will be opened or closed
                    if (!isCollapsed || isMobile) {
                      handleSubMenuToggle2(item.label);
                    }

                    // if sidebar is closed,
                    // and viewport is not for mobile,
                    // and if item has submenu, sidebar will open
                    if (isCollapsed && !isMobile && hasSubItems) {
                      setIsCollapsed(false);
                    }

                    // if viewport is for mobile, and if you click item without submenu, the sidebar will close.
                    // if sidebar item has a submenu, the main item will not cause sidebar to close.
                    else if (isMobile && !hasSubItems) {
                      setIsCollapsed(false);
                    }
                  }}
                  component={!hasSubItems ? Link : "div"}
                  to={!hasSubItems ? item.path : undefined}
                  sx={{
                    ...parentStyles,
                    minHeight: "48px",
                    borderRadius: "10px",
                    justifyContent:
                      isCollapsed && !isMobile ? "center" : "center",
                    px: 2,
                    // border:'2px solid red'
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: isActive ? "#006CB8" : "white",
                      minWidth: 0,
                      mr: 2,
                      justifyContent: "center",
                      position: "relative",
                      left: isMobile ? "0px" : isCollapsed ? "37px" : "0px",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  <ListItemText
                    primary={item.label}
                    sx={{ textWrap: "nowrap" }}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: FontFamilyValue,
                        opacity: !isCollapsed || isMobile ? 1 : 0,
                        display: !isCollapsed || isMobile ? "block" : "none",
                        fontSize: "15px",
                        fontWeight: "500",
                      },
                    }}
                  />

                  {hasSubItems &&
                    (!isCollapsed || isMobile) &&
                    (isSubMenuOpen ? <ExpandLess /> : <ExpandMore />)}
                </ListItem>

                {/* Submenu */}
                {hasSubItems && (!isCollapsed || isMobile) ? (
                  <Collapse in={isSubMenuOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.subItems.map((subItem, subIndex) => {
                        const isSubActive = location.pathname === subItem.path;

                        return (
                          <ListItem
                            key={subIndex}
                            button
                            component={Link}
                            to={subItem.path}
                            onClick={() => {
                              if (isMobile) {
                                // if mobile viewport, clicking the submenu item
                                // will close the sidebar
                                setIsCollapsed(false);
                              }
                            }}
                            sx={{
                              pl: 4,
                              minHeight: "48px",
                              color: isSubActive ? "#006CB8" : "white",
                              background: isSubActive ? "white" : "#006CB8",
                              transition: "all 0.3s ease-in-out",
                              "&:hover": {
                                backgroundColor: isSubActive
                                  ? "white"
                                  : "#006CB8",
                                color: isSubActive ? "#006CB8" : "white",
                                transition: "all 0.3s ease-in-out",
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                color: isSubActive ? "#006CB8" : "white",
                                position: "relative",
                                left: "30px",
                              }}
                            >
                              {subItem.icon}
                            </ListItemIcon>

                            <ListItemText
                              primary={subItem.label}
                              primaryTypographyProps={{
                                sx: {
                                  fontFamily: FontFamilyValue,
                                  fontSize: "15px",
                                  fontWeight: "400",
                                },
                              }}
                            />
                          </ListItem>
                        );
                      })}
                    </List>
                  </Collapse>
                ) : null}
              </div>
            );
          })}
        </List>
      </Drawer>

      {/* Main Content Area */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100vh",
        }}
      >
        {/* Navbar */}

        <AppBar
          position="static"
          sx={{
            minHeight: "80px", // Ensures a minimum height of 100px
            background: "white",
            color: "black",
            px: 2,
            display: viewNav ? "flex" : "none",
            justifyContent: "center", // Centers the content vertically
            boxShadow: "none",
            borderBottom: "2px solid #E6F1F8",
          }}
        >
          <div
            style={{
              height: "10px",
              borderTop: "10px solid #006CB8",
              position: "fixed",
              width: "100vw",
              left: "0px",
              top: "0px",
            }}
          ></div>
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "100%",
            }}
          >
            {/* Left Section */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {isMobile && (
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => setIsCollapsed(!isCollapsed)}
                >
                  <MenuIcon sx={{ color: "black", fontSize: "40px" }} />
                </IconButton>
              )}
            </Box>

            {/* Right Section */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 1,
                mr: 3,
              }}
            >
              {/* Notifications Icon with Badge */}
              {/* <IconButton color="inherit">
                <Badge badgeContent={notificationCount} color="error">
                  <NotificationsIcon
                    sx={{ color: "#006CB8", fontSize: "40px" }}
                    onClick={() => {
                      Navigate(`/Notifications`);
                    }}
                  />
                </Badge>
              </IconButton> */}

              {/* Profile Section */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                }}
              >
                <Avatar
                  // src={avatar}
                  sx={{
                    width: 50,
                    height: 50,
                    border: "2px solid lightgrey",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                  onClick={() => {
                    Navigate(`/Profile`);
                  }}
                >
                  {clientData?.CD_Name ? clientData?.CD_Name[0] : ""}
                </Avatar>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: FontFamilyValue,
                      color: "black",
                      fontSize: "18px",
                      position: "relative",
                      top: "8px",
                    }}
                  >
                    {clientData?.CD_Name}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: FontFamilyValue,
                      color: "black",
                      fontSize: "12px",
                      position: "relative",
                      bottom: "5px",
                    }}
                  >
                    Client
                    {/* Expand Icon triggers the dropdown */}
                    <IconButton onClick={handleClick}>
                      <ExpandMoreIcon sx={{ color: "black" }} />
                    </IconButton>
                  </Typography>
                </Box>

                {/* Dropdown Menu */}
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Adjusts initial position
                  transformOrigin={{ vertical: "top", horizontal: "right" }} // Controls where it expands from
                  sx={{
                    "& .MuiPaper-root": {
                      width: "200px", // Adjust width
                      marginTop: "25px", // Moves it further down
                      borderRadius: "8px", // Optional: Rounded corners,
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      Navigate(`/Profile`);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Profile"
                    />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpenModal(true);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <LockResetIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Change Password"
                    />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      // Navigate(`/SystemSettings`);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <SettingsIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      onClick={handleOpen2}
                      primary="Settings"
                    />
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      localStorage.removeItem("SWA_userRole");
                      localStorage.removeItem("SWA_token");
                      localStorage.removeItem("SWA_UserId");
                      sessionStorage.removeItem("SWA_userRole");
                      sessionStorage.removeItem("SWA_token");
                      sessionStorage.removeItem("SWA_UserId");

                      Navigate("/Login/Client");
                      window.location.reload();
                    }}
                  >
                    <ListItemIcon>
                      <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Logout"
                    />
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Content View */}
        <ClientLayoutProvider
          value={{
            clientData,
          }}
        >
          {/* Navbar & Sidebar here */}
          <Box sx={{ flex: 1, overflowY: "auto", backgroundColor: "white" }}>
            {children}
          </Box>
        </ClientLayoutProvider>
      </Box>

      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-settings-title"
        aria-describedby="modal-settings-description"
      >
        <Box
          sx={{
            ...style,
            p: 3,
            borderRadius: 3,
            backgroundColor: "#fff",
            width: 400,
            border: "none",
          }}
        >
          <Typography id="modal-settings-title" variant="h6" mb={2}>
            Personalised Settings
          </Typography>

          {/* Custom SelectInput for Notification Medium */}
          <SelectInput
            placeholder="Choose Notification Medium"
            name="notification_medium"
            // value={staffData.notification_medium}
            // onChange={handleInputChange}
            // error={!!errors.notification_medium}
            options={[
              { value: "email", label: "Email" },
              { value: "sms", label: "SMS" },
              { value: "push", label: "Push Notification" },
            ]}
          />

          <FormControlLabel
            control={
              <Switch
                checked={autoDelete}
                onChange={(e) => setAutoDelete(e.target.checked)}
              />
            }
            label="Auto delete notifications"
            sx={{ my: 2 }}
          />

          {autoDelete && (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="delete-frequency-label">
                Delete Frequency
              </InputLabel>
              <Select
                labelId="delete-frequency-label"
                id="delete-frequency"
                value={deleteFrequency}
                label="Delete Frequency"
                onChange={(e) => setDeleteFrequency(e.target.value)}
              >
                <MenuItem value="1">After 1 day</MenuItem>
                <MenuItem value="7">After 7 days</MenuItem>
                <MenuItem value="30">After 30 days</MenuItem>
              </Select>
            </FormControl>
          )}

          {/* Buttons */}
          <Grid
            container
            spacing={2}
            justifyContent={{ xs: "center", sm: "flex-end" }}
          >
            <Grid item>
              <CommonButton
                variant="outlined"
                customColor="#B0BEC5"
                onClick={handleClose2}
              >
                Cancel
              </CommonButton>
            </Grid>
            <Grid item>
              <CommonButton
                variant="contained"
                customColor="#007BFF"
                onClick={handleClose2}
              >
                Save
              </CommonButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}
